/**
 * Pathless layout for authenticated routes. TanStack Router collects
 * every file under `routes/_authenticated/` and wraps them in this
 * component. The beforeLoad guard kicks unauthenticated users to /login.
 *
 * The guard reads the persisted Zustand store synchronously, so first
 * paint never flashes the dashboard for a logged-out user. /me is
 * still fetched in AuthBootstrap to confirm the session is live.
 */
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { Shell } from '../components/layout/shell';
import { useAuthStore } from '../stores/auth-store';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: () => {
    const state = useAuthStore.getState();
    if (state.status === 'unauthenticated') {
      throw redirect({ to: '/login' });
    }
  },
  component: () => (
    <Shell>
      <Outlet />
    </Shell>
  ),
});
